import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from 'react-to-print';
import { getUserRole, numberToWords } from "../../../lib/utils";
// import config from "../../../config";
import client from "../../../clients";

export default function PaymentSlip(props) {

  const payment = props.payment;
  const printRef = useRef();
  const [taxes, setTaxes] = useState([]);
  const [isPooledMemberView, setPooledMemberView] = useState(true);
  



  // const handlePrint = useReactToPrint({
  //  documentTitle: 'Title',
  //  contentRef: printRef,
  // })


  const toggleSwitchPooledMemberView = () => {
    setPooledMemberView(!isPooledMemberView)
  }

  const handlePrint = useReactToPrint({
    documentTitle: `${payment?.invoice_number} ${payment?.member?.[0]?.userInfo?.name?"- " + payment.member[0].userInfo.name:''}`,
    content: () => printRef.current, 
     pageStyle: `
      @page {
        margin: 0;
      }
      @media print {
        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          color: #000000 !important;
          opacity: 1 !important;
          font-family: 'Arial', sans-serif !important;
        }
        body {
          background: #ffffff !important;
          font-family: 'Arial', sans-serif !important;
        }
        #pool-member-display-switch {
          display: none !important;
        }
        ${!isPooledMemberView ? `#pool-member-view { display: none !important; }` : ''}
      }
    `
  })

  const getRoles = (profiles = []) => {
    let res = "", role = payment?.membership?.[0]?.enquiry?.[0]?.closed_by_role || '';
    if (profiles?.length) {
      let roles = [];

      profiles.forEach(profile => {
        if (profile?.roles?.length) {
          roles = [...roles, ...(profile?.rolelist || [])];
        }
      });

      if (role != '') roles = roles.filter(d => d.role == role);

      roles.sort((a, b) => a.role - b.role); // Sort ascending by d.role


      res = roles?.[0]?.name ? client.config.roleNames[roles?.[0]?.name] :'';
      //roles.map(d => client.config.roleNames[d.name]).join(", ");
    }
    return res;
  };

  const collectiveBilling = payment?.membership?.reduce((acc, m) => {
    const b = m.billedInfo;
    return {
      subTotal:      acc.subTotal      + parseFloat(b.subTotal?.$numberDecimal      || 0),
      surCharges:    acc.surCharges    + parseFloat(b.surCharges?.$numberDecimal    || 0),
      totalTax:      acc.totalTax      + parseFloat(b.totalTax?.$numberDecimal      || 0),
      payableAmount: acc.payableAmount + parseFloat(b.payableAmount?.$numberDecimal || 0),
      rackRate:      acc.rackRate      + parseFloat(b.rackRate?.$numberDecimal      || 0),
      basePrice:     acc.basePrice     + parseFloat(b.basePrice?.$numberDecimal     || 0),
      baseAmount:    acc.baseAmount    + parseFloat(b.baseAmount?.$numberDecimal    || 0),
      discount:      acc.discount      + parseFloat(b.discount?.$numberDecimal      || 0),
    };
  }, { subTotal:0, surCharges:0, totalTax:0, payableAmount:0, rackRate:0, basePrice:0, baseAmount:0, discount:0 });

const collectiveBalance = payment?.membership?.reduce((acc, m) =>
  acc + parseFloat(m.balance_amount?.$numberDecimal ?? m.balance_amount ?? 0), 0);
    
  useEffect(() => {
    if (payment?.membership?.length) {
      const seen = new Set();
      const allTaxes = payment.membership.flatMap(m => m.taxes).filter(t => {
        if (seen.has(t._id)) return false;
        seen.add(t._id);
        return true;
      });
      setTaxes(allTaxes);
    }
  }, [payment]);



  const getPayableAmount = (payment) => {
    const billedInfo = payment.membership[0].billedInfo;
    const storedPayable = Number(billedInfo.payableAmount?.$numberDecimal || 0);

    // If stored payable amount exists and is valid, use it directly
    if (storedPayable > 0) return storedPayable;

    // Manual fallback calculation
    const rackRate   = Number(billedInfo.rackRate.$numberDecimal || 0);
    const discount   = Number(payment.discount?.$numberDecimal || 0);
    const surcharge  = Number(billedInfo.surCharges.$numberDecimal || 0);
    const writeOff   = payment.isBalanceWriteOff
                        ? Number(payment.writeOffAmount?.$numberDecimal ?? payment.writeOffAmount ?? 0)
                        : 0;
    const isInclusive = billedInfo.taxType !== "additional-tax";
    const totalTaxRate = payment.membership[0].taxes.reduce(
      (sum, t) => sum + Number(t.value), 0
    );

    let payable;

    if (!billedInfo.taxType || billedInfo.taxType === "") {
      // No tax
      payable = rackRate - discount - writeOff + surcharge;
    } else if (isInclusive) {
      // Tax already baked into rackRate, no extra addition
      payable = rackRate - discount - writeOff + surcharge;
    } else {
      // Additional tax — add on top
      const taxableAmount = rackRate - discount - writeOff;
      const taxAmount = (taxableAmount * totalTaxRate) / 100;
      payable = taxableAmount + taxAmount + surcharge;
    }

    return Math.round(payable); // or .toFixed(2) if decimals needed
  };


  const getTotalPayment = () =>{
    let value = 0;

    console.log(payment)

    if(payment){
      if(payment?.amount?.$numberDecimal) value = value + parseFloat(payment.amount.$numberDecimal);
      payment.balance_payments.forEach(balance=>{
        if(balance?.amount?.$numberDecimal) value = value + parseFloat(balance.amount.$numberDecimal);
      })
    }

    return value;
  }
  
  const assignedTrainer =
    payment?.membership?.find((m) => m.trainer?.[0]?.name)?.trainer?.[0] ||
    payment?.membership?.[0]?.trainer?.[0] ||
    null;
  if(!payment) return <></>;


  return (
    <>
      <div className="global-modal-container payment-slip d-flex">
        <div className="flex-item margin-auto slideBottomToTop" style={{width: window.innerWidth > 767 ? "auto" : "100%", height:"100%"}}>
          <div className="d-flex w-full space-between m-t-20 m-b-20" style={{padding: window.innerWidth < 768 ? "0 12px" : "0", gap:"12px", flexWrap:"nowrap"}}>
              <button
                className="flex-item"
                onClick={() => {
                  printRef.current.style.overflowY = 'visible';
                  handlePrint();
                }}
                style={{ padding: window.innerWidth < 768 ? "8px 12px" : "10px 20px", cursor: "pointer", fontSize: window.innerWidth < 768 ? "13px" : "14px", whiteSpace:"nowrap", flexShrink:0 }}
              >
                Print / Save as PDF
              </button>
              <div onClick={()=>props.handleViewPaymentSlip()} className="d-flex flex-item close-payment-view-preview cursor-pointer" style={{flexShrink:0}}>
              <svg className="flex-item margin-auto" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.64648 16.4583L17.3548 0.75M17.3548 16.4583L1.64648 0.75" stroke="#ffffff" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          {/* Printable Area */}
          {/* Printable Area */}
           <div className="flex-item margin-auto" style={{overflow: 'auto', borderRadius:"20px", height:"88%", width: window.innerWidth < 768 ? "94vw" : "auto", backgroundColor:"#ffffff", WebkitOverflowScrolling:'touch'}}>
             <div ref={printRef} style={{height:"100%", margin:"0 auto", alignSelf:"center"}}>
              <div ref={printRef} style={{height:"100%", margin:"0 auto", alignSelf:"center"}}>
              <div className="page" style={{pageBreakAfter: "always", width:"auto", maxWidth:"297mm", minHeight: "400mm", padding: "20mm", background: "#ffffff", boxSizing: "border-box", margin:"0 auto", position:"relative"}}>
                <p style={{fontWeight:"700", fontSize:"18px"}}>Payment Logs</p>

                <div style={{display:"flex", borderBottom:"1px solid #e0e0e0", paddingBottom:"12px", marginTop:"20px", marginBottom:"12px"}}>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"20px", fontSize:"16px"}}>#</p>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"150px", fontSize:"16px"}}>Payment Date</p>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"150px", fontSize:"16px"}}>Amount Paid</p>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"200px", fontSize:"16px"}}>Payment Mode</p>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"300px", fontSize:"16px"}}>Invoice/Receipt No</p>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"200px", fontSize:"16px"}}>Received By</p>
                </div>

                <div style={{display:"flex"}}>
                  <p style={{alignSelf:"flex-item", fontWeight:600, width:"20px", fontSize:"16px"}}>1</p>
                  <p style={{alignSelf:"flex-item", fontWeight:600, width:"150px", fontSize:"16px"}}>{payment.invoiceDateString}</p>
                  <p style={{alignSelf:"flex-item", fontWeight:600, width:"150px", fontSize:"16px"}}>{payment.amount.$numberDecimal}</p>
                  <p style={{alignSelf:"flex-item", fontWeight:600, width:"200px", fontSize:"16px"}}>{`${payment.mode}` == 'Tez'?'Google Pay':payment.mode}</p>
                  <p style={{alignSelf:"flex-item", fontWeight:600, width:"300px", fontSize:"16px"}}>{payment.invoice_number}</p>
                  <p style={{alignSelf:"flex-item", fontWeight:600, width:"200px", fontSize:"16px"}}>{payment.received_by.length?payment.received_by[0].name:'-'}</p>
                </div>

                {
                  payment.balance_payments.map((balance,index)=>{
                    return (
                      <div style={{display:"flex"}}>
                        <p style={{alignSelf:"flex-item", fontWeight:600, width:"20px", fontSize:"16px"}}>{index+2}</p>
                        <p style={{alignSelf:"flex-item", fontWeight:600, width:"150px", fontSize:"16px"}}>{balance.invoiceDateString}</p>
                        <p style={{alignSelf:"flex-item", fontWeight:600, width:"150px", fontSize:"16px"}}>{balance?.amount?.$numberDecimal}</p>
                        <p style={{alignSelf:"flex-item", fontWeight:600, width:"200px", fontSize:"16px"}}>{`${balance.mode}` == 'Tez'?'Google Pay':balance.mode}</p>
                        <p style={{alignSelf:"flex-item", fontWeight:600, width:"300px", fontSize:"16px"}}>{balance?.invoice_number}</p>
                        <p style={{alignSelf:"flex-item", fontWeight:600, width:"200px", fontSize:"16px"}}>{balance?.received_by.length?balance?.received_by[0].name:'-'}</p>
                      </div>
                    )
                  })
                }


                {
                  payment.branch[0].branchconfigs[0].tc && (
                    <>
                    <div style={{height:"1px", marginTop:"40px", marginBottom:"20px", background:"#e0e0e0"}}/>

                    <p style={{fontWeight:"700", fontSize:"18px", marginBottom:"10px"}}>Terms & Conditions</p>

                    <div style={{fontSize:"13px",whiteSpace: "pre-line"}}>{payment.branch[0].branchconfigs[0].tc}</div>
                    
                    {/* <p style={{fontSize:"16px"}}>1. Membership Fee is non-Refundable.</p>
                    <p style={{fontSize:"16px"}}>2. Membership cannot be freezed.</p>
                    <p style={{fontSize:"16px"}}>3. Membership Transfer charges Rs. 2000 plus taxes & applicable only for Annual memberships.</p>
                    <p style={{fontSize:"16px"}}>4. Membership can be Transferred only to a Non member Only ( Member who has never been a member with Urbounce)</p>
                    <p style={{fontSize:"16px"}}>5. Package mentioned on the receipt in only applicable ( *** Anything communicated verbally is not applicable unless mentioned on the receipt in printed format) .</p>
                    <p style={{fontSize:"16px"}}>6. Workout Hours at URBOUNCE.</p>
                    <p style={{fontSize:"16px"}}>7. LOCK DOWN days will not be freezed, added or extended in any case for any of our memberships.</p>
                    <p style={{fontSize:"16px"}}>8. Right to admission is reserved</p> */}
                    </>
                  )
                }

                <div style={{position:"absolute", bottom: 0, width:"86%"}}>
                  <div style={{justifyContent:"space-between", display:"flex"}}>
                    <div style={{alignSelf:"flex-start", width:"500px"}}>
                      <p style={{fontWeight:"700", fontSize:"18px"}}>Authorized By:</p>
                      <p style={{fontWeight:"700", fontSize:"18px", marginTop:"8px"}}>{payment.membership?.[0]?.enquiry?.[0]?.closed_by_user?.[0]?.name} ({getRoles(payment.membership?.[0]?.enquiry?.[0]?.closed_by_user?.[0]?.profiles)})</p>
                    </div>
                    <div style={{alignSelf:"flex-start", width:"360px"}}>
                      <div style={{display:"flex"}}>
                        <p style={{fontWeight:"700", fontSize:"18px"}}>Member's Signature</p>
                        <div style={{width:"150px", height:"1px", background:"#000000", marginTop:"20px", marginLeft:"12px"}} />
                      </div>
                      <p style={{fontStyle:"italic", marginTop:"8px", lineHeight:"18px"}}>*Note: This is computer generated invoice, signature is not required.</p>
                    </div>
                  </div>
                </div>

              </div>
              <div className="page" style={{pageBreakAfter: "always", width:"auto", maxWidth:"297mm", minHeight: "400mm", padding: "20mm", background: "#ffffff", boxSizing: "border-box", position:"relative"}}>
                <div style={{width:"100%",textAlign:"center"}}>
                  <p style={{fontSize:"24px", fontWeight:"700" }}>{(payment.membership[0].balance_amount || payment?.membership?.[0].billedInfo?.taxType == "" || payment?.membership?.[0].taxes.length == 0) ? "PAYMENT RECEIPT":"TAX INVOICE"}</p>
                </div>
                <div style={{display:"flex", justifyContent:"space-between", marginTop:"80px"}}>
                  <div style={{alignSelf:"flex-start", width:"420px"}}>
                    {/* <img style={{width:"auto", height:"100px"}} src={`https://picsum.photos/200/300`} /> */}
                    
                    {/* LOGO (logoFileID) WILL FETCH FROM BRANCH - UPDATED */}
                    {
                      (payment.branch[0].logoFileID) && (
                        <img style={{width:"auto", height:"100px", marginBottom:"12px"}} src={`${client.config.API_URL}/image/file/${payment.branch[0].logoFileID}/auto/300/90?${Date.now()}`} loading='lazy' />
                      )
                    }
                    {/* <p className='flex-item' style={{
                      color: "#ffffff",
                      margin: "0 auto",
                      fontSize: 14,
                    }}>{`${payment.branch[0].name}`.trim()[0]}</p>
                  </div> */}
                    <p style={{fontWeight:"700", fontSize:"22px", marginBottom:"20px"}}>{payment.branch[0].name}</p>
                    
                    {payment.branch[0].branchconfigs[0].gstIn && <p style={{fontSize:"18px", marginBottom:"4px"}}>GSTIN: <span style={{fontWeight:"700"}}>{payment.branch[0].branchconfigs.length?payment.branch[0].branchconfigs[0].gstIn:""}</span></p>}
                    {payment.branch[0].branchconfigs.length && payment.branch[0].branchconfigs[0].sac_code&&<p style={{fontSize:"18px", marginBottom:"4px"}}>SAC Code: <span style={{fontWeight:"700"}}>{payment.branch[0].sac_code}</span></p>}
                    {payment.branch[0].address && <p style={{fontSize:"18px", marginBottom:"4px"}}>Address: <span style={{fontWeight:"700"}}>{payment.branch[0].address}</span></p>}
                    {payment.branch[0].phone && <p style={{fontSize:"18px", marginBottom:"4px"}}>Phone: <span style={{fontWeight:"700"}}>{payment.branch[0].phone}</span></p>}
                    {payment.branch[0].state && <p style={{fontSize:"18px"}}>Place Of Supply: <span style={{fontWeight:"700"}}>{payment.branch[0].state}</span></p>}
                    {assignedTrainer?.name && (
                      <div style={{marginTop:"28px", borderRadius:"0 6px 6px 0"}}>
                        <p style={{fontSize:"16px", color:"#2b2b2b"}}>Assigned Trainer</p>
                        <p style={{fontWeight:"700", fontSize:"18px", marginTop:"2px"}}>
                          {assignedTrainer.name}
                          {assignedTrainer.phone ? <span style={{fontWeight:"400"}}> ({assignedTrainer.phone})</span> : null}
                        </p>
                      </div>
                    )}
                    {
                      (payment.membership.length>0 && payment.membership[0].transferred_by_user && payment.membership[0].transferred_by_user.length>0) ? (
                        <div style={{marginBottom:"50px"}}>
                          <p style={{fontWeight:"700", marginTop:"50px", fontSize:"18px", marginBottom:"4px"}}>Transferred :</p>
                          <p style={{fontWeight:"normal", marginTop:"12px", fontSize:"16px", marginBottom:"4px"}}>From: <span style={{fontWeight:"700"}}>{payment.membership[0].transferred_by_user[0].name} ({payment.membership[0].transferred_by_user[0].phone})</span></p>
                          <p style={{fontWeight:"normal", marginTop:"8px", fontSize:"16px", marginBottom:"4px"}}>To: <span style={{fontWeight:"700"}}>{payment?.user[0].name} ({payment?.user[0].phone})</span></p>
                          <p style={{fontWeight:"normal", marginTop:"8px", fontSize:"16px", marginBottom:"4px"}}>Sessions: <span style={{fontWeight:"700"}}>{Number(payment.membership[0].transferred_memberships[0].completed_sessions || 0)} of {Number(payment.membership[0].transferred_memberships[0].sessions) + Number(payment.membership[0].transferred_memberships[0]?.add_on_days || 0)}</span></p>
                        </div>
                      ) : [
                        <p style={{fontWeight:"700", marginTop:"50px", fontSize:"18px", marginBottom:"4px"}}>{payment.user[0].name}</p>,
                        payment.user[0].email && <p style={{fontSize:"18px", fontWeight:"700", marginBottom:"4px"}}>{payment.user[0].email}</p>,
                        <p style={{fontSize:"18px", fontWeight:"700", marginBottom:"4px"}}>{payment.user[0].phone}</p>,
                        payment.user[0].gstin_number && <p style={{fontSize:"18px", fontWeight:"700", marginBottom:"4px"}}>GSTIN: {payment.user[0].gstin_number}</p>
                      ]
                    }
                  </div>
                  <div style={{alignSelf:"flex-start", textAlign:"right"}}>
                    <p style={{alignSelf:"flex-end", fontSize:"18px", fontWeight:"700"}}><span style={{fontWeight:"700"}}>Date:</span> {payment.invoiceDateString}</p>
                    <p style={{alignSelf:"flex-end", fontSize:"18px", fontWeight:"700"}}>Invoice No: {payment.invoice_number}</p>
                  </div>
                </div>


                {
                  payment?.membership?.[0]?.pooledMembers?.length > 0 && isPooledMemberView && (
                    <div id="pool-member-view" style={{width:"100%", marginTop:"20px", marginBottom:"10px"}}>
                      <p style={{fontWeight:"600", marginBottom:"8px", fontSize:"16px"}}>Pooled Members</p>
                      <div style={{display:"flex", flexWrap:"wrap", alignItems:"flex-start", width:"100%"}}>
                        {
                          payment.membership[0].pooledMembers.map((pm, pmi) => {
                            return(
                              <div style={{alignSelf:"flex-start", marginRight:"16px", paddingRight:"16px", marginBottom:"12px", borderRight: payment.membership[0].pooledMembers.length != pmi + 1  ? "1px solid #9a9a9a" : ""}}>
                                <p style={{fontWeight:"700", fontSize:"14px"}}>Name: {pm.name}</p>
                                <p style={{fontWeight:"700", fontSize:"14px"}}>Phone: {pm.phone}</p>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  )
                }
                {
                  payment?.membership?.[0]?.pooledMembers?.length > 0 && (
                    <div id="pool-member-display-switch" className="d-flex" style={{marginBottom:"40px", marginTop: !isPooledMemberView && "16px"}}>
                      <p className="flex-item m-r-12 color-dark-blue font-weight-600" style={{fontStyle:"italic"}}>Show pooled member while printing/downloading bill</p>
                      <div onClick={()=>toggleSwitchPooledMemberView()} className='toggle-button d-flex cursor-pointer' style={{backgroundColor: isPooledMemberView == true && "#B3E28F"}}>
                        <div className='toggle-ball flex-item' style={{right: isPooledMemberView ? 0:'auto', left: !isPooledMemberView ? 0:'auto', backgroundColor: isPooledMemberView && "#5d883c"}} />
                      </div>
                    </div>
                  )
                }
               

                <div style={{display:"flex", borderBottom:"1px solid #e0e0e0", paddingBottom:"12px", marginTop:"20px", marginBottom:"12px"}}>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"20px", fontSize:"16px"}}>#</p>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"300px", fontSize:"16px"}}>Description</p>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"120px", fontSize:"16px"}}>Duration</p>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"120px", fontSize:"16px"}}>Sessions</p>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"120px", fontSize:"16px"}}>Start Date</p>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"120px", fontSize:"16px"}}>End Date</p>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"120px", fontSize:"16px"}}>Cost</p>
                  <p style={{alignSelf:"flex-item", fontWeight:800, width:"120px", fontSize:"16px"}}>Discount</p>
                </div>

                
                {
                  payment.membership.length > 0 && payment.membership.map((m,index) => {
                    return(
                      <div style={{display:"flex", marginBottom:"12px"}}>
                        <p style={{alignSelf:"flex-item", fontWeight:600, width:"20px", fontSize:"16px"}}>{index + 1}.</p>
                        <p style={{alignSelf:"flex-item", fontWeight:600, width:"300px", fontSize:"16px"}}>{m.membershipplans?.[0]?.name}</p>
                        {/* <p style={{alignSelf:"flex-item", fontWeight:600, width:"120px", fontSize:"16px"}}>{m.membershipplans?.[0]?.packages.find(d => d.sessions == m.sessions)?.duration || m.duration || m.sessions} {m.membershipplans?.[0]?.packages.find(d => d.sessions == m.sessions)?.durationType === "months" ? "Month" : m.membershipplans?.[0]?.packages.find(d => d.sessions === m.sessions)?.durationType || m.durationType || 'Day'}</p> */}
                        <p style={{alignSelf:"flex-item", fontWeight:600, width:"120px", fontSize:"16px"}}>
                          {
                            m.membershipplans?.[0]?.packages.find(
                              d => d.sessions == m.sessions
                            )?.duration || m.duration || m.sessions
                          }{" "}
                          {
                            (
                              m.membershipplans?.[0]?.packages.find(
                                d => d.sessions == m.sessions
                              )?.durationType ||
                              m.duration_unit ||
                              m.durationType ||
                              ""
                            ).toLowerCase().includes("month")
                              ? "Month"
                              : (
                                  m.membershipplans?.[0]?.packages.find(
                                    d => d.sessions == m.sessions
                                  )?.durationType ||
                                  m.duration_unit ||
                                  m.durationType ||
                                  ""
                                ).toLowerCase().includes("day")
                              ? "Day"
                              : "Day"
                          }
                        </p>
                        <p style={{alignSelf:"flex-item", fontWeight:600, width:"120px", fontSize:"16px"}}>{m.membershipplans?.[0]?.packages?.find(d=>d.sessions == m.sessions)?.sessions || m.sessions}</p>
                        {
                          (payment.membership.length>0 && m.upgraded_from_memberships.length>0) ? (
                            <p style={{alignSelf:"flex-item", fontWeight:600, width:"120px", fontSize:"16px"}}>{m.upgraded_from_memberships[0]?.starts_at_string}</p>
                          ) : (
                            <p style={{alignSelf:"flex-item", fontWeight:600, width:"120px", fontSize:"16px"}}>{m.starts_at_string}</p>
                          )
                        }
                        <p style={{alignSelf:"flex-item", fontWeight:600, width:"120px", fontSize:"16px"}}>{m.ends_at_string}</p>
                        {/* payment.membership?.[0]?.billedInfo?.baseAmount?.$numberDecimal ||  */}
                        <p style={{alignSelf:"flex-item", fontWeight:600, width:"120px", fontSize:"16px"}}>₹ {m.billedInfo.rackRate.$numberDecimal != 0?m.billedInfo.rackRate.$numberDecimal:m.membershipplans?.[0]?.packages?.find(d=>d.sessions == m.sessions)?.rackRate?.$numberDecimal || m.membershipplans?.[0]?.packages?.find(d=>d.sessions == m.sessions)?.rackRate}</p>
                        <p style={{alignSelf:"flex-item", fontWeight:600, width:"120px", fontSize:"16px"}}>₹ {m?.billedInfo?.discount?.$numberDecimal ? m.billedInfo.discount.$numberDecimal : 0}</p>
                      </div>
                      )
                  }) 
                }

                <div style={{justifyContent:"space-between", display:"flex", marginTop:"60px"}}>
                  <div style={{alignSelf:"flex-start", width:"500px"}}>
                    <p style={{fontSize:"18px", marginBottom:"14px"}}>Paid Amount (in words): <span style={{fontWeight:"700",textTransform:'capitalize'}}>{payment.isBalanceWriteOff?numberToWords(getTotalPayment()):numberToWords(getTotalPayment())}</span></p>
                    {/* <p style={{fontSize:"18px", marginBottom:"14px"}}>Paid Amount (in words): <span style={{fontWeight:"700",textTransform:'capitalize'}}>{payment.isBalanceWriteOff?numberToWords(getTotalPayment()):numberToWords(payment.membership[0].billedInfo.payableAmount.$numberDecimal)}</span></p> */}
                    { payment.mode && (<p style={{fontSize:"18px"}}><span style={{fontWeight:"700"}}>Payment Mode:</span> {`${payment.mode}` == 'Tez'?'Google Pay':payment.mode}</p>)}
                    { (payment.upiId || payment.user[0].aadhar_number || payment.user[0].phone) && <p style={{fontSize:"18px"}}><span style={{fontWeight:"700"}}>Mobile Number/Adhaar No/UPI Id:</span> {payment.upiId?payment.upiId:payment.user[0].aadhar_number?payment.user[0].aadhar_number:payment.user[0].phone}</p>}
                    { payment.bankName && <p style={{fontSize:"18px"}}><span style={{fontWeight:"700"}}>Bank Name:</span> {payment.bankName}</p>}
                    { payment.source && <p style={{fontSize:"18px"}}><span style={{fontWeight:"700"}}>Source:</span> {payment.source}</p>}
                    { payment.cardType && <p style={{fontSize:"18px"}}><span style={{fontWeight:"700"}}>Card Type:</span> {payment.cardType}</p>}
                    { payment.chequeNumber && <p style={{fontSize:"18px"}}><span style={{fontWeight:"700"}}>Cheque Number:</span> {payment.chequeNumber}</p>}   
                    { payment.transactionID && <p style={{fontSize:"18px"}}><span style={{fontWeight:"700"}}>Transaction ID:</span> {payment.transactionID}</p>}
                    { payment.paymentNumber && <p style={{fontSize:"18px"}}><span style={{fontWeight:"700"}}>Payment Number:</span> {payment.paymentNumber}</p>}
                    { payment.approvedCode && <p style={{fontSize:"18px"}}><span style={{fontWeight:"700"}}>Approved Code:</span> {payment.approvedCode}</p>}
                    {
                      payment?.razorPay?.razorpayOrderId && (
                        <p style={{fontSize:"18px"}}><span style={{fontWeight:"700"}}>Order ID:</span> {payment.razorPay.razorpayOrderId}</p>
                      )
                    }
                    {
                      payment?.razorPay?.razorpayPaymentId && (
                        <p style={{fontSize:"18px"}}><span style={{fontWeight:"700"}}>Approved ID:</span> {payment.razorPay.razorpayPaymentId}</p>
                      )
                    }
                  </div>
                  <div style={{alignSelf:"flex-start"}}>
                    <div style={{display:"flex", marginBottom:"8px"}}>
                      <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                        <p style={{fontWeight:"700", fontSize:"18px"}}>Selected Plans Total:</p>
                      </div>
                      <div style={{width:"100px", textAlign:"right"}}>
                        {/* <p style={{fontWeight:"700", fontSize:"18px"}}>₹ {Number(payment?.membership?.[0]?.billedInfo?.payableAmount?.$numberDecimal || payment.membership[0].membershipplans?.[0]?.packages?.[0].rackRate) + Number(payment?.membership?.[0]?.upgraded_from_memberships?.[0]?.billedInfo?.payableAmount?.$numberDecimal || 0)}</p> */}
                        <p style={{fontWeight:"700", fontSize:"18px"}}>₹ { payment?.package?.[0]?.total_amount ? payment.package[0].total_amount : Number(payment.membership[0].billedInfo.rackRate.$numberDecimal)}</p>
                      </div>
                    </div>
                    {payment?.membership?.reduce((sum, m) => sum + parseFloat(m.billedInfo?.poolCharge?.$numberDecimal || 0), 0) > 0 && (
                      <div style={{display:"flex", marginBottom:"8px"}}>
                          <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                            <p style={{fontWeight:"700", fontSize:"18px"}}>Pool Charge:</p>
                          </div>
                          <div style={{width:"100px", textAlign:"right"}}>
                            <p style={{fontWeight:"700", fontSize:"18px"}}>+ ₹ {payment.membership.reduce((sum, m) => sum + parseFloat(m.billedInfo?.poolCharge?.$numberDecimal || 0), 0)}</p>
                          </div>
                        </div>
                      )
                    }
                    {payment.isBalanceWriteOff && <div style={{display:"flex", marginBottom:"4px"}}>
                      <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                        <p style={{fontSize:"18px"}}>Amount Written Off:</p>
                      </div>
                      <div style={{width:"100px", textAlign:"right"}}>
                        <p style={{fontSize:"18px"}}>- ₹ {payment?.writeOffAmount?.$numberDecimal ?? payment?.writeOffAmount ?? 0}</p>
                      </div>
                    </div>}
                    { (payment.membership.length>0 && payment.membership[0].upgraded_from_memberships.length>0) &&
                    <>
                    <div style={{display:"flex", marginBottom:"4px"}}>
                      <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                        <p style={{fontSize:"18px"}}>Prorated Credit:</p>
                      </div>
                      <div style={{width:"100px", textAlign:"right"}}>
                        <p style={{fontSize:"18px"}}>- ₹ {Number(payment?.membership?.[0]?.upgraded_from_memberships?.[0]?.billedInfo?.payableAmount?.$numberDecimal || 0)}</p>
                      </div>
                    </div>
                    {/* <div style={{display:"flex", marginBottom:"4px"}}>
                      <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                        <p style={{fontSize:"18px"}}>Upgraded Amount:</p>
                      </div>
                      <div style={{width:"100px", textAlign:"right"}}>
                        <p style={{fontSize:"18px"}}>₹ {Number(payment?.membership?.[0]?.billedInfo?.payableAmount?.$numberDecimal || payment.membership[0].membershipplans?.[0]?.packages?.[0].rackRate)}</p>
                      </div>
                    </div> */}
                    </>}
                    <div style={{display:"flex", marginBottom:"2px"}}>
                      <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                        <p style={{fontSize:"18px"}}>Total Discount:</p>
                      </div>
                      <div style={{width:"100px", textAlign:"right"}}>
                        <p style={{fontSize:"18px"}}>- ₹ {payment.discount?payment.discount.$numberDecimal:0}</p>
                      </div>
                    </div>
                    {/* <div style={{display:"flex", marginBottom:"4px"}}>
                      <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                        <p style={{fontSize:"18px"}}>CGST (2.5%):</p>
                      </div>
                      <div style={{width:"100px", textAlign:"right"}}>
                        <p style={{fontSize:"18px"}}>₹67.38</p>
                      </div>
                    </div> */}
                    {/* <div style={{display:"flex", marginBottom:"4px"}}>
                      <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                        <p style={{fontSize:"18px"}}>SGST (2.5%):</p>
                      </div>
                      <div style={{width:"100px", textAlign:"right"}}>
                        <p style={{fontSize:"18px"}}>₹67.38</p>
                      </div>
                    </div> */}

                    {
                      (payment.membership[0].billedInfo.taxType != "" && payment?.membership?.[0].taxes.length > 0) && (
                        <div style={{display:"flex", marginBottom:"4px"}}>
                          <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                            <p style={{fontSize:"18px"}}>{payment.skipAggregateTax == true ? "Net Amount:" :  payment.gstOnPaidAmount == true ? "Gross Amount:" : "Taxable Amount:" }</p>
                          </div>
                          <div style={{width:"100px", textAlign:"right"}}>
                            <p style={{ fontSize: "18px" }}>
                              ₹ {(() => {
                                const memberships = payment.membership;

                                const proratedCredit = payment.membership?.[0]?.upgraded_from_memberships?.length > 0 ? Number(payment.membership[0].upgraded_from_memberships[0].billedInfo ?.payableAmount?.$numberDecimal || 0 ) : 0;

                                return memberships.reduce((total, membership) => {
                                  const rackRate = Number(membership.billedInfo.rackRate.$numberDecimal);
                                  const poolCharge = Number(membership.billedInfo.poolCharge?.$numberDecimal || 0);

                                  const discount = Number(payment.discount?.$numberDecimal || 0) / memberships.length;

                                  const isInclusive = membership.billedInfo.taxType !== "additional-tax";

                                  const totalTaxRate = membership.taxes.reduce(
                                    (sum, t) => sum + Number(t.value),
                                    0
                                  );

                                  const writtenOff = payment?.writeOffAmount?.$numberDecimal ?? payment?.writeOffAmount ?? 0;

                                  const amountAfterDiscount = Math.max(0,rackRate + poolCharge - discount - (payment.membership?.[0]?.upgraded_from_memberships?.length > 0 ? proratedCredit : 0));

                                  const finalAmount = amountAfterDiscount - writtenOff;

                                  const base = isInclusive ? Math.floor(finalAmount / (1 + totalTaxRate / 100)) : Math.floor(finalAmount);

                                  return total + base;
                                }, 0);
                              })()}
                            </p>
                          </div>
                        </div>
                      )
                    }

                                      
                    {payment?.membership?.[0]?.billedInfo?.taxType !== "" &&
                    (() => {
                      const taxMap = {};

                      const proratedCredit =
                        payment?.membership?.[0]?.upgraded_from_memberships?.length > 0
                          ? Number(
                              payment.membership[0].upgraded_from_memberships[0].billedInfo
                                ?.payableAmount?.$numberDecimal || 0
                            )
                          : 0;

                      payment.membership.forEach((membership) => {
                        const rackRate = Number(membership.billedInfo?.rackRate?.$numberDecimal || 0);
                        const poolCharge = Number(membership.billedInfo.poolCharge?.$numberDecimal || 0);

                        const discount = Number(payment.discount?.$numberDecimal || 0) / payment.membership.length;

                        const isInclusive = membership.billedInfo.taxType !== "additional-tax";

                        const totalTaxRate = membership.taxes.reduce((sum, t) => sum + Number(t.value || 0),0);

                        const writtenOff = payment.skipAggregateTax != true && (payment?.writeOffAmount?.$numberDecimal ?? payment?.writeOffAmount ?? 0);

                        const netAmount = payment.gstOnPaidAmount ? getTotalPayment() : Math.max(0,rackRate + poolCharge - discount - proratedCredit - writtenOff);

                        membership.taxes.forEach((tax) => {
                          let taxAmount = 0;

                          if (isInclusive) {
                            const inclusiveTax =
                              (netAmount * totalTaxRate) / (100 + totalTaxRate);

                            taxAmount =
                              (inclusiveTax * Number(tax.value || 0)) /
                              totalTaxRate;
                          } else {
                            taxAmount =
                              (netAmount * Number(tax.value || 0)) / 100;
                          }

                          if (taxMap[tax.name]) {
                            taxMap[tax.name].amount += taxAmount;
                          } else {
                            taxMap[tax.name] = {
                              amount: taxAmount,
                              value: tax.value,
                              isInclusive,
                            };
                          }
                        });
                      });

                      return Object.entries(taxMap).map(
                        ([taxName, { amount, value, isInclusive }]) => (
                          <div
                            key={taxName}
                            style={{ display: "flex", marginBottom: "4px" }}
                          >
                            <div
                              style={{
                                width: "280px",
                                textAlign: "right",
                                marginRight: "20px",
                              }}
                            >
                              <p style={{ fontSize: "18px" }}>
                                {taxName} ({value}%)
                                {isInclusive && " (Inclusive)"}:
                              </p>
                            </div>

                            <div
                              style={{
                                width: "100px",
                                textAlign: "right",
                              }}
                            >
                            <p style={{ fontSize: "18px" }}>
                              ₹ {amount.toFixed(2)}
                            </p>
                          </div>
                        </div>
                        )
                      );
                    })()}
                                        
                    {/* {
                      payment?.membership?.[0].billedInfo?.taxType != "" && payment?.membership?.[0].taxes.map(tax => {
                        const base = Number(payment.membership?.[0]?.billedInfo?.baseAmount?.$numberDecimal || payment.membership?.[0]?.membershipplans?.[0]?.packages?.[0]?.rackRate || 0);

                        const surcharge = Number(payment.membership?.[0]?.billedInfo?.surCharges?.$numberDecimal || 0);

                        const discount = Number(payment?.discount?.$numberDecimal || 0);

                        const taxableAmount = base - discount + surcharge;

                          const taxAmount = ((taxableAmount * tax.value) / 100).toFixed(2);

                          return (
                            <div style={{ display: "flex", marginBottom: "4px" }} key={tax.name}>
                              <div style={{ width: "200px", textAlign: "right", marginRight: "30px" }}>
                                <p style={{ fontSize: "18px" }}>
                                  {tax.name} ({tax.value}%):
                                </p>
                              </div>

                              <div style={{ width: "100px", textAlign: "right" }}>
                                <p style={{ fontSize: "18px" }}>
                                  ₹ {taxAmount}
                                </p>
                              </div>
                            </div>
                          );
                        })
                      }


                            <div style={{ width: "100px", textAlign: "right" }}>
                              <p style={{ fontSize: "18px" }}>
                                ₹ {taxAmount}
                              </p>
                            </div>
                          </div>
                        );
                      })
                    } */}

                    <div style={{display:"flex", marginBottom:"2px"}}>
                      <div style={{width:"280px", textAlign:"right", marginRight: "20px"}}>
                        <p style={{fontSize:"18px"}}>Sub Total:</p>
                      </div>
                      <div style={{width:"100px", textAlign:"right"}}>
                        <p style={{fontSize:"18px"}}>₹ {payment.membership.reduce((sum, m) => sum + parseFloat(m.billedInfo.subTotal.$numberDecimal || 0), 0)}</p>
                      </div>
                    </div>
                    <div style={{display:"flex", marginBottom:"2px"}}>
                      <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                        <p style={{fontSize:"18px"}}>Surcharge({Math.round((payment.membership[0].billedInfo.surCharges.$numberDecimal/(payment.membership?.[0]?.billedInfo?.baseAmount?.$numberDecimal || payment.membership?.[0]?.membershipplans?.[0]?.packages?.[0]?.rackRate))*100)}%):</p>
                      </div>
                      <div style={{width:"100px", textAlign:"right"}}>
                        <p style={{fontWeight:"700", fontSize:"18px"}}>₹ {payment.membership.reduce((sum, m) => sum + parseFloat(m.billedInfo.surCharges.$numberDecimal || 0), 0)}</p>
                      </div>
                    </div>
                    {console.log(payment.membership)}
                    <div style={{display:"flex", marginBottom:"2px"}}>
                      <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                        <p style={{fontWeight:"700", fontSize:"18px"}}>Payable Amount:</p>
                      </div>
                      <div style={{width:"100px", textAlign:"right"}}>
                        <p style={{fontWeight:"700", fontSize:"18px"}}>₹ {payment.isBalanceWriteOff ? getTotalPayment() : payment.membership.reduce((sum, m) => sum + parseFloat(m.billedInfo.payableAmount.$numberDecimal || 0), 0)}</p>
                      </div>
                    </div>
                    <div style={{display:"flex", marginBottom:"2px"}}>
                      <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                        <p style={{fontSize:"18px"}}>Amount Paid:</p>
                      </div>
                      <div style={{width:"100px", textAlign:"right"}}>
                        <p style={{fontSize:"18px"}}>₹ {getTotalPayment()}</p>
                      </div>
                    </div>
                    {
                      payment.membership[0].payment_due_date && (
                        <div style={{display:"flex", marginBottom:"2px"}}>
                          <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                            <p style={{fontSize:"18px"}}>Balance Amount:</p>
                          </div>
                          <div style={{width:"100px", textAlign:"right"}}>
                            <p style={{fontSize:"18px"}}>₹ {payment.membership[0].balance_amount?.$numberDecimal || payment.membership[0].balance_amount}</p>
                          </div>
                        </div>
                      )
                    }
                    {
                      payment?.package?.[0]?.payment_due_date && (
                        <div style={{display:"flex", marginBottom:"2px"}}>
                          <div style={{width:"280px", textAlign:"right", marginRight: "20px",}}>
                            <p style={{fontSize:"18px"}}>Balance Amount:</p>
                          </div>
                          <div style={{width:"100px", textAlign:"right"}}>
                            <p style={{fontSize:"18px"}}>₹ {payment?.package?.[0]?.balance_amount}</p>
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>

                { payment.membership?.[0]?.comment && <p style={{fontSize:"18px"}}><span style={{fontWeight:"700"}}>Comment:</span> {payment?.membership?.[0]?.comment}</p>}


                {
                  payment.branch[0].branchconfigs[0].tc && (
                    <>
                    <div style={{height:"1px", marginTop:"40px", marginBottom:"20px", background:"#e0e0e0"}}/>

                    <p style={{fontWeight:"700", fontSize:"18px", marginBottom:"10px"}}>Terms & Conditions</p>

                    <div className="m-b-8" style={{fontSize:"13px",whiteSpace: "pre-line"}}>{payment.branch[0].branchconfigs[0].tc}</div>
                    
                    {/* <p style={{fontSize:"16px"}}>1. Membership Fee is non-Refundable.</p>
                    <p style={{fontSize:"16px"}}>2. Membership cannot be freezed.</p>
                    <p style={{fontSize:"16px"}}>3. Membership Transfer charges Rs. 2000 plus taxes & applicable only for Annual memberships.</p>
                    <p style={{fontSize:"16px"}}>4. Membership can be Transferred only to a Non member Only ( Member who has never been a member with Urbounce)</p>
                    <p style={{fontSize:"16px"}}>5. Package mentioned on the receipt in only applicable ( *** Anything communicated verbally is not applicable unless mentioned on the receipt in printed format) .</p>
                    <p style={{fontSize:"16px"}}>6. Workout Hours at URBOUNCE.</p>
                    <p style={{fontSize:"16px"}}>7. LOCK DOWN days will not be freezed, added or extended in any case for any of our memberships.</p>
                    <p style={{fontSize:"16px"}}>8. Right to admission is reserved</p> */}
                    </>
                  )
                }

              
                {/* <div style={{height:"1px", marginTop:"40px", marginBottom:"20px", background:"#e0e0e0"}}/>

                <p style={{fontWeight:"700", fontSize:"18px", marginBottom:"10px"}}>Terms & Conditions</p>
                
                <p style={{fontSize:"16px"}}>1. Membership Fee is non-Refundable.</p>
                <p style={{fontSize:"16px"}}>2. Membership cannot be freezed.</p>
                <p style={{fontSize:"16px"}}>3. Membership Transfer charges Rs. 2000 plus taxes & applicable only for Annual memberships.</p>
                <p style={{fontSize:"16px"}}>4. Membership can be Transferred only to a Non member Only ( Member who has never been a member with Urbounce)</p>
                <p style={{fontSize:"16px"}}>5. Package mentioned on the receipt in only applicable ( *** Anything communicated verbally is not applicable unless mentioned on the receipt in printed format) .</p>
                <p style={{fontSize:"16px"}}>6. Workout Hours at URBOUNCE.</p>
                <p style={{fontSize:"16px"}}>7. LOCK DOWN days will not be freezed, added or extended in any case for any of our memberships.</p>
                <p style={{fontSize:"16px"}}>8. Right to admission is reserved</p> */}


                <div style={{position:"absolute", bottom: 0, width:"86%"}}>
                  <div style={{justifyContent:"space-between", display:"flex"}}>
                    <div style={{alignSelf:"flex-start", width:"500px"}}>
                      <p style={{fontWeight:"700", fontSize:"18px"}}>Authorized By:</p>
                      <p style={{fontWeight:"700", fontSize:"18px", marginTop:"8px"}}>{payment.membership?.[0]?.enquiry?.[0]?.closed_by_user?.[0]?.name} ({getRoles(payment.membership?.[0]?.enquiry?.[0]?.closed_by_user?.[0]?.profiles)})</p>
                    </div>
                    <div style={{alignSelf:"flex-start", width:"360px"}}>
                      <div style={{display:"flex"}}>
                        <p style={{fontWeight:"700", fontSize:"18px"}}>Member's Signature</p>
                        <div style={{width:"150px", height:"1px", background:"#000000", marginTop:"20px", marginLeft:"12px"}} />
                      </div>
                      <p style={{fontStyle:"italic", marginTop:"8px", lineHeight:"18px"}}>*Note: This is computer generated invoice, signature is not required.</p>
                    </div>
                  </div>
                </div>
              
              </div>
              {
              (payment.membership.length>0 && payment.membership[0].upgraded_from_memberships.length>0) &&
                <div className="page" style={{pageBreakAfter: "always", width:"auto", maxWidth:"297mm", minHeight: "400mm", padding: "20mm", background: "#ffffff", boxSizing: "border-box", position:"relative"}}>
                  <div style={{height:"1px", marginTop:"40px", marginBottom:"20px", background:"#e0e0e0"}}/>
                  <p style={{fontWeight:"700", fontSize:"26px", marginBottom:"30px"}}>UPGRADED FROM:</p>
                  <p style={{fontSize:"16px", marginBottom:"30px"}}><span style={{fontWeight:"700", marginRight:"8px"}}>{payment.membership[0].upgraded_from_memberships[0].membershipplans[0].name} Invoice No:</span>{payment.membership[0].upgraded_from_memberships[0].payments[0].invoice_number} <span style={{fontWeight:"700", margin:"0 0 0 20px", marginRight:"8px"}}>Date:</span>7/02/2026</p>
                  <div style={{display:"flex", justifyContent:"space-between", width:"550px", marginBottom:"12px"}}>
                    <div style={{display:"flex", justifyContent:"space-between", width:"240px"}}>
                      <p style={{fontSize:"16px"}}>Duration:</p>
                      <p style={{fontSize:"16px", fontWeight:"700"}}>{payment.membership[0].upgraded_from_memberships[0].membershipplans?.[0]?.packages?.[0].durationType}</p>
                    </div>
                    <div style={{display:"flex", justifyContent:"space-between", width:"240px"}}>
                      <p style={{fontSize:"16px"}}>Payable amount:</p>
                      {/* <p style={{fontSize:"16px", fontWeight:"700"}}>₹{payment.membership[0].upgraded_from_memberships[0]?.billedInfo?.payableAmount?.$numberDecimal}</p> */}
                      <p style={{fontSize:"16px", fontWeight:"700"}}>₹{payment.isBalanceWriteOff ? getTotalPayment() : getPayableAmount(payment)}</p>
                    </div>
                  </div>
                  <div style={{display:"flex", justifyContent:"space-between", width:"550px", marginBottom:"12px"}}>
                    <div style={{display:"flex", justifyContent:"space-between", width:"240px"}}>
                      <p style={{fontSize:"16px"}}>Start date:</p>
                      <p style={{fontSize:"16px", fontWeight:"700"}}>{payment.membership[0].upgraded_from_memberships[0]?.starts_at_string}</p>
                    </div>  
                    <div style={{display:"flex", justifyContent:"space-between", width:"240px"}}>
                      <p style={{fontSize:"16px"}}>End date:</p>
                      <p style={{fontSize:"16px", fontWeight:"700"}}>{payment.membership[0].upgraded_from_memberships[0]?.ends_at_string}</p>
                    </div>
                  </div>
                  <div style={{display:"flex", justifyContent:"space-between", width:"240px"}}>
                    <p style={{fontSize:"16px"}}>Session:</p>
                    <p style={{fontSize:"16px", fontWeight:"700"}}>{Number(payment.membership[0].upgraded_from_memberships[0].completed_sessions || 0)}/{Number(payment.membership[0].upgraded_from_memberships[0].sessions) + Number(payment.membership[0].upgraded_from_memberships[0]?.add_on_days || 0)}</p>
                  </div> 
                  
                  
                  <div style={{position:"absolute", bottom: 0, width:"86%"}}>
                    <div style={{justifyContent:"space-between", display:"flex"}}>
                      <div style={{alignSelf:"flex-start", width:"500px"}}>
                        <p style={{fontWeight:"700", fontSize:"18px"}}>Authorized By:</p>
                        <p style={{fontWeight:"700", fontSize:"18px", marginTop:"8px"}}>{payment.membership?.[0]?.enquiry?.[0]?.closed_by_user?.[0]?.name} ({getRoles(payment.membership?.[0]?.enquiry?.[0]?.closed_by_user?.[0]?.profiles)})</p>
                      </div>
                      <div style={{alignSelf:"flex-start", width:"360px"}}>
                        <div style={{display:"flex"}}>
                          <p style={{fontWeight:"700", fontSize:"18px"}}>Member's Signature</p>
                          <div style={{width:"150px", height:"1px", background:"#000000", marginTop:"20px", marginLeft:"12px"}} />
                        </div>
                        <p style={{fontStyle:"italic", marginTop:"8px", lineHeight:"18px"}}>*Note: This is computer generated invoice, signature is not required.</p>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}